import { render, staticRenderFns } from "./SearchComponent.vue?vue&type=template&id=0ab9eab6"
import script from "./SearchComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchComponent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports